import styles from '../../css/Modal.module.css';
import SelectComponent from '../select/SelectComponent';

export default function Modal({
	state,
	setState,
	nullData,
	modal,
	setModal,
	checkedMenus,
	setCheckedMenus,
	setCheckedArray,
	reportBusiness,
	checkedCodeMenus, 
    setCheckedCodeMenus,
	setAnalDetailData,
}) {

	const handleBtn = () => {
		setCheckedMenus([])
		setCheckedCodeMenus([])
		setModal({...modal, modalSelect:false})
	}

	//Select input
	const menuOpenHandler = () => {
		setModal({...modal, modalSelect: false})
		setAnalDetailData(checkedCodeMenus);
	}

	return (
		<div className={styles.wrap}>
			<div className={`${modal.modalPolygon ? styles.modalContainer : styles.selectContainer} ${styles.container}`}>
				{/* <div className={styles.titleArea}>
					<h1>상권분석</h1>
					<button type='button' onClick={handleBtn} className={styles.closeBtn}>
						<img src='img/icon_close.png' alt='close btn' />
					</button>
				</div> */}
				<>
					<SelectComponent 
						// state={state}
						// setState={setState}
						nullData={nullData}
						checkedMenus={checkedMenus}
						setCheckedMenus={setCheckedMenus}
						checkedCodeMenus={checkedCodeMenus}
						setCheckedCodeMenus={setCheckedCodeMenus}
						// checkedArray={checkedArray}
						className={styles.content}
					/>
					<div className={styles.btnArea}>
						<button onClick={handleBtn} type='reset' style={{marginRight: '8px'}}>취소</button>
						<button type='submit' 
										onClick={menuOpenHandler} 
										disabled={checkedMenus.length === 0}
										style={checkedMenus.length === 0 ? 
											{cursor: 'not-allowed', backgroundColor: '#edecec', color: '#000'} : 
											{cursor: 'pointer', backgroundColor: 'rgb(134, 178, 253)', color:'#fff'}}
						>확인</button>
					</div>
				</>
			</div>
		</div>
	)
}